import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function Settings() {
  const { user, tenant } = useAuth();

  return (
    <div>
      <h1 className="text-xl font-bold text-dark-800 mb-4">Settings</h1>

      <div className="grid gap-4 lg:grid-cols-2">
        <div className="bg-white rounded-xl border border-dark-200 p-5">
          <h2 className="font-semibold text-dark-800 mb-3">Profile</h2>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between"><span className="text-dark-400">Name</span><span className="font-medium">{user?.full_name}</span></div>
            <div className="flex justify-between"><span className="text-dark-400">Email</span><span className="font-medium">{user?.email}</span></div>
            <div className="flex justify-between"><span className="text-dark-400">Role</span><span className="font-medium capitalize">{user?.role}</span></div>
          </div>
        </div>

        <div className="bg-white rounded-xl border border-dark-200 p-5">
          <h2 className="font-semibold text-dark-800 mb-3">Organization</h2>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between"><span className="text-dark-400">Company</span><span className="font-medium">{tenant?.company_name}</span></div>
            <div className="flex justify-between"><span className="text-dark-400">Tenant Code</span><span className="font-medium">{tenant?.tenant_code}</span></div>
            <div className="flex justify-between"><span className="text-dark-400">Status</span><span className="font-medium capitalize">{tenant?.status}</span></div>
          </div>
        </div>
      </div>
    </div>
  );
}
